import $ from 'jquery';
import {createStore} from 'zustand/vanilla';
import {useStore} from 'zustand';

const hydrateFromDom = () => {
    if (typeof document === 'undefined') {
        return {total: '', hasQuotation: false, hasItems: false, count: 0};
    }
    const info = document.querySelector('.js-cart-short-info-block');
    const totalEl = document.querySelector('.shopping-cart-total');
    return {
        total: totalEl?.textContent?.trim() ?? '',
        hasQuotation: Number(info?.dataset?.cartHasQuotation ?? 0) === 1,
        hasItems: Number(info?.dataset?.cartHasItems ?? 0) === 1,
        count: 0,
    };
};

export const cartStore = createStore((set) => ({
    ...hydrateFromDom(),
    mutationVersion: 0,
    setCart: (patch, options = {}) => set((state) => {
        const next = {...state, ...patch};
        if (patch.count !== undefined) {
            next.hasItems = patch.count > 0;
        }
        if (!options.silent) {
            next.mutationVersion = state.mutationVersion + 1;
        }
        return next;
    }),
}));

const writeShortInfoBlockAttrs = (state, prev) => {
    if (typeof document === 'undefined') return;
    const el = document.querySelector('.js-cart-short-info-block');
    if (!el) return;
    if (state.hasQuotation !== prev?.hasQuotation) {
        el.setAttribute('data-cart-has-quotation', state.hasQuotation ? 1 : 0);
    }
    if (state.hasItems !== prev?.hasItems) {
        el.setAttribute('data-cart-has-items', state.hasItems ? 1 : 0);
    }
};

const parseTotalToNumber = (total) => {
    const s = String(total ?? '').replace('€ ', '').replaceAll('.', '').replace(',', '.');
    return Number(s);
};

const writeOrderLimitNotification = (total) => {
    const $eleOrderLimit = $('.js-shopping-cart-order-limit');
    if (!$eleOrderLimit.length) return;
    const hasOrderLimit = Number($eleOrderLimit.attr('data-has-order-limit')) === 1;
    if (!hasOrderLimit) {
        $eleOrderLimit.addClass('d-none');
        $('.js-cart-order-limit').addClass('d-none');
        $('.js-cart-order-limit-cta-next').removeClass('d-none');
        return;
    }
    const orderLimit = Number($eleOrderLimit.text());
    const totalNumber = parseTotalToNumber(total);
    if (orderLimit < totalNumber) {
        $('.js-cart-order-limit').removeClass('d-none');
        $('.js-cart-order-limit-cta-next').addClass('d-none');
    } else {
        $('.js-cart-order-limit').addClass('d-none');
        $('.js-cart-order-limit-cta-next').removeClass('d-none');
    }
};

const writeCartTotalDom = (total) => {
    const $cartTotal = $('.shopping-cart-total');
    if (!$cartTotal.length) return;
    $cartTotal.text(total);
    const isEmpty = total == 0 || total == null || total === '';
    const $hostedTotal = $('[data-shoppingcart]').find('.shopping-cart-total');
    if (isEmpty) {
        $hostedTotal.removeClass('badge');
    } else {
        $hostedTotal.addClass('badge');
    }
    writeOrderLimitNotification(total);
};

cartStore.subscribe((state, prev) => {
    writeShortInfoBlockAttrs(state, prev);
    if (state.total !== prev?.total) {
        writeCartTotalDom(state.total);
    }
});

export const getCartSnapshot = () => cartStore.getState();

export const setCart = (patch, options) => cartStore.getState().setCart(patch, options);

export const subscribeCart = (listener) => cartStore.subscribe(listener);

export const useCartState = (selector = (s) => s) => useStore(cartStore, selector);
